import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { isUserPlanExpired, getPlanInfo } from "utils/authHelpers";

const enumToPlanName = {
  1: "Wellcheck",
  2: "Plus",
  3: "Premium",
  4: "Trial",
};

const TrialProtectedRoute = ({ element }) => {
  const trialExpired = isUserPlanExpired();
  const planId = getPlanInfo(); // e.g., 1

  const displayPlanName = enumToPlanName[planId] || "your";

  if (trialExpired) {
    toast.warning(
      `Your ${displayPlanName} plan has expired. Please renew or upgrade to continue.`,
      { toastId: "trial-expired-warning" }
    );
    return <Navigate to="/plans" replace />;
  }

  return element;
};

TrialProtectedRoute.propTypes = {
  element: PropTypes.node.isRequired,
};

export default TrialProtectedRoute;
